<template>
  <div class="voice-cloning">
    <!-- 添加声音克隆 -->
    <div class="add-clone-button">
      <el-card class="add-card" @click="handleAddVoice">
        <div class="add-icon">
          <el-icon>
            <CirclePlusFilled />
          </el-icon>
        </div>
        <p>添加声音克隆</p>
      </el-card>
    </div>

    <!-- Tab部分 -->
    <el-tabs v-model="activeTab" class="tabs">
      <!-- 声音库 -->
      <el-tab-pane label="声音库" name="voice-library">
        <div class="content">
          <!-- 声音库部分 -->
          <el-row class="voice-row">
            <div class="voice-card-wrapper" v-for="(voice, index) in voiceLibrary" :key="index">
              <el-card :body-style="{ padding: '20px' }" shadow="hover">
                <div class="voice-card">
                  <!-- 播放按钮 -->
                  <div class="play-button" @click="togglePlay(index, 'library')">
                    <svg v-if="!voice.isPlaying" xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                      viewBox="0 0 56 56">
                      <circle cx="28" cy="28" r="28" fill="#FF5C00"></circle>
                      <path
                        d="M21.5 20.5c0-1.8 2.1-3 3.6-2l12.5 8.1c1.4.9 1.4 3 0 3.9l-12.5 8.1c-1.5 1-3.6-.1-3.6-2V20.5z"
                        fill="#fff" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 56 56">
                      <circle cx="28" cy="28" r="28" fill="#FF5C00"></circle>
                      <rect x="20" y="18" width="5" height="20" rx="2.5" fill="#fff"></rect>
                      <rect x="31" y="18" width="5" height="20" rx="2.5" fill="#fff"></rect>
                    </svg>
                  </div>

                  <!-- 声音信息 -->
                  <div class="voice-info">
                    <div class="title-row">
                      <p class="title">{{ voice.title }}</p>
                      <el-button type="text" size="big" class="create-button" @click="handleCreate(voice)">
                        操作
                      </el-button>
                    </div>
                    <p class="tag">{{ voice.model }}</p>
                  </div>
                </div>
              </el-card>
            </div>
          </el-row>

        </div>
      </el-tab-pane>

      <!-- 我的声音 -->
      <el-tab-pane label="我的声音" name="my-voice">
        <div class="content">
          <!-- 分类按钮 -->
          <div class="filter-buttons">
            <button v-for="filter in filters" :key="filter"
              :class="['filter-button', { active: selectedFilter === filter }]" @click="handleFilterClick(filter)">
              {{ filter }}
            </button>
          </div>

          <!-- 我的声音部分 -->
          <el-row class="voice-row">
            <div class="voice-card-wrapper" v-for="(voice, index) in filteredMyVoices" :key="index">
              <el-card :body-style="{ padding: '20px' }" shadow="hover">
                <div class="voice-card">
                  <!-- 播放按钮 -->
                  <div class="play-button" @click="togglePlay(index, 'my-voice')">
                    <svg v-if="!voice.isPlaying" xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                      viewBox="0 0 56 56">
                      <circle cx="28" cy="28" r="28" fill="#FF5C00"></circle>
                      <path
                        d="M21.5 20.5c0-1.8 2.1-3 3.6-2l12.5 8.1c1.4.9 1.4 3 0 3.9l-12.5 8.1c-1.5 1-3.6-.1-3.6-2V20.5z"
                        fill="#fff" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 56 56">
                      <circle cx="28" cy="28" r="28" fill="#FF5C00"></circle>
                      <rect x="20" y="18" width="5" height="20" rx="2.5" fill="#fff"></rect>
                      <rect x="31" y="18" width="5" height="20" rx="2.5" fill="#fff"></rect>
                    </svg>
                  </div>

                  <!-- 声音信息 -->
                  <div class="voice-info">
                    <div class="title-row">
                      <p class="title">{{ voice.title }}</p>
                      <el-dropdown trigger="click" class="create-button">
                        <el-button type="text" size="big" style="color: #FF5C00;font-weight: bold;">
                          操作
                        </el-button>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item @click="openRenameDialog(voice)">命名</el-dropdown-item>
                            <el-dropdown-item @click="onDownload(voice)">下载</el-dropdown-item>
                            <el-dropdown-item @click="openDeleteDialog(voice)">
                              <span style="color: red; font-weight: bold;">删除</span>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                    <p class="tag">{{ voice.scene }}</p>
                  </div>
                </div>
              </el-card>
            </div>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 右侧抽屉 -->
    <el-drawer v-model="drawerVisible" :title="drawerTitle" direction="rtl" size="22%">
      <div class="drawer-content">
        <!-- 第一步：上传音频要求 -->
        <div v-if="drawerStep === 1" class="step-1">
          <div class="upload-requirements">
            <h3>上传音频要求</h3>
            <ul>
              <li style="margin-bottom: 15px;">应确保仅有一个人说话人，以避免多人声音混杂。</li>
              <li style="margin-bottom: 15px;">要尽量降低背景噪音，确保说话人的发音清晰，以提高后续的音频克隆效果。</li>
              <li style="margin-bottom: 15px;">录制过程中，应保持稳定的音量和语速，注意合理的断句，并避免产生如口水声等口腔噪音和其他杂音、混响。</li>
              <li style="margin-bottom: 15px;">要尽量减少桌椅移动声、键盘鼠标敲击声以及衣物摩擦声等人为噪声的干扰。</li>
              <li style="margin-bottom: 15px;">在录制过程中，如果出现口误，无需中断录音，可在短暂停顿后继续录制。</li>
            </ul>
          </div>


          <!-- 下一步按钮 -->
          <div class="next-step">
            <el-button type="primary" @click="drawerStep = 2"
              style="background-color: #ff5c00;border: none;">下一步</el-button>
          </div>
        </div>

        <!-- 第二步：上传音频和创建专属音色 -->
        <div v-else class="step-2">
          <h3>创建您的专属音色</h3>
          <p class="subtitle">通过上传您录制的语音，轻松复刻您的专属音色。</p>

          <!-- 上传音频区域 -->
          <div class="upload-section">
            <el-upload class="upload-voice" :before-upload="beforeUpload" :on-success="handleSuccess"
              :on-error="handleError" :limit="1" :file-list="fileList">
              <div class="upload-box">
                <el-icon class="upload-icon">
                  <UploadFilled />
                </el-icon>
                <p class="upload-text">点击上传音频文件</p>
                <p class="upload-hint">支持 mp3/wav 音频 最大 {{ voiceDuration }}s，最小 5s，最大 {{ voiceSize }}M</p>
              </div>
            </el-upload>
          </div>


          <!-- 音色名称输入 -->
          <div class="name-input">
            <h3>名称</h3>
            <el-input v-model="VoiceName" placeholder="我的音色名称" />
          </div>

          <!-- 音色名称输入 -->
          <div class="name-input">
            <h3>场景</h3>
            <el-input v-model="VoiceScene" placeholder="我的音色场景" />
          </div>
          <!-- 免责声明 -->
          <div class="disclaimer">
            <h3>免责声明</h3>
            <ul>
              <li>请确认您使用的音频已获取其本人或团队授权。</li>
              <li>您承诺您上传的音频严格遵守中国的法律法规要求，不涉及黄、赌、毒，及任何形式的政治敏感信息等。</li>
              <li>如果您违反上述规定，存在任何违法行为，由此产生的所有法律责任由使用者自行承担。</li>
            </ul>
          </div>

          <!-- 取消和立即复刻按钮 -->
          <div class="action-buttons">
            <el-button @click="drawerStep = 1">取消复刻</el-button>
            <el-button type="primary" :loading="isLoading" @click="handleClone"
              style="background-color: #ff5c00;border: none;">立即复刻</el-button>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 删除确认模态框 -->
    <el-dialog v-model="deleteDialogVisible" title="删除确认" width="30%">
      <p>确定要删除 <strong>{{ currentItem?.title }}</strong> 吗？</p>
      <template #footer>
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">确认删除</el-button>
      </template>
    </el-dialog>

    <!-- 修改模态框 -->
    <el-dialog v-model="renameDialogVisible" title="修改声音信息" width="30%">
      <el-form :model="renameForm" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="renameForm.title" placeholder="请输入新的标题" />
        </el-form-item>
        <el-form-item label="场景">
          <el-input v-model="renameForm.scene" placeholder="请输入新的场景" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="renameDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmRename" style="background: #FF5C00;border: none;">确认修改</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { CirclePlusFilled, UploadFilled } from "@element-plus/icons-vue";
import axios from 'axios';
import { auth } from "@/utils/auth.js"; // 引入封装的 auth.js
import config from '@/config.js'; // 引入配置文件
import { ElMessage } from "element-plus";

export default {
  name: "VoiceCloning",
  components: {
    CirclePlusFilled,
    UploadFilled,
  },
  data() {
    return {
      activeTab: "voice-library",
      selectedFilter: "全部", // 默认选中的 Filter
      voiceLibrary: [], // 存储公模数据
      myVoices: [], // 存储私模数据
      isLoading: false,  // 控制按钮 loading 状态
      filters: ["全部"], // 动态生成的分类按钮
      audioElement: null, // 用于控制音频播放的 DOM 元素
      currentPlayingIndex: null, // 当前正在播放的音频索引
      currentPlayingType: null, // 当前正在播放的音频类型（library 或 my-voice）
      deleteDialogVisible: false, // 控制删除模态框显示
      renameDialogVisible: false, // 控制修改模态框显示
      currentItem: null, // 当前操作的项
      drawerVisible: false, // 控制抽屉显示
      drawerStep: 1, // 抽屉步骤，1 表示第一步，2 表示第二步
      fileList: [], // 上传的文件列表
      VoiceName: "", // 音色名称
      VoiceScene: "", // 音色场景
      voiceDuration: 0, // 音频最大时长（秒）
      voiceSize: 0, // 音频最大大小（MB）
      renameForm: {
        title: "", // 修改后的标题
        scene: "", // 修改后的场景
      },
    };
  },
  computed: {
    // 根据选中的分类过滤数据
    filteredMyVoices() {
      if (this.selectedFilter === "全部") {
        return this.myVoices;
      }
      return this.myVoices.filter(voice => voice.model === this.selectedFilter);
    },
    // 动态设置抽屉标题
    drawerTitle() {
      return this.drawerStep === 1 ? "复刻第一步" : "复刻第二步";
    },
  },
  created() {
    this.fetchVoiceData(); // 页面加载时获取数据
    this.fetchvoiceClarityValues();
  },
  methods: {
    // 获取声音数据
    async fetchVoiceData() {
      const user = auth.getStoredUser(); // 从本地存储获取用户信息
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_sc_api.php`, {
          action: "get",
          user_id: user.id, // 使用本地存储的 user_id
        });

        if (response.data.success) {
          const data = response.data.data;

          // 分类数据
          this.voiceLibrary = data.filter(item => item.is_open > 0); // 公模数据
          this.myVoices = data.filter(item => item.is_open === 0); // 私模数据

          // 动态生成 filters
          const models = [...new Set(this.myVoices.map(item => item.model))]; // 去重
          this.filters = ["全部", ...models]; // 添加 "全部" 选项
        } else {
          this.$message.error("获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败，请检查网络");
      }
    },

    // 立即复刻按钮点击事件
    async handleClone() {
      if (!this.VoiceName) {
        ElMessage.error("请输入音色名称");
        return;
      }
      if (this.fileList.length === 0) {
        ElMessage.error("请上传音频");
        return;
      }
      this.isLoading = true;
      const startTime = Date.now();
      try {
        const user = auth.getStoredUser();
        if (!user || !user.id) {
          ElMessage.error("用户未登录或用户ID无效");
          return;
        }

        // 调用后端接口保存音频信息
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_sc_api.php`, {
          action: "add",
          user_id: user.id,
          title: this.VoiceName,
          scene: this.VoiceScene,
          voice_url: this.fileList[0].url, // 假设上传成功后返回了音频 URL
          size_dx: this.fileList[0].size, // 文件大小
        });

        if (response.data.success) {
          ElMessage.success("复刻操作成功");
          this.drawerVisible = false; // 关闭抽屉
          this.fetchVoiceData(); // 刷新数据
        } else {
          ElMessage.error(response.data.error || "复刻操作失败");
        }
      } catch (error) {
        console.error("复刻操作失败:", error);
        ElMessage.error("复刻操作失败，请检查网络");
      } finally {
        // 计算已消耗的时间
        const elapsed = Date.now() - startTime;
        const remainingTime = 3000 - elapsed;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.isLoading = false;
          }, remainingTime);
        } else {
          this.isLoading = false;
        }
      }
    },
    // 播放或停止音频
    togglePlay(index, type) {
      const voiceList = type === "library" ? this.voiceLibrary : this.filteredMyVoices; // 使用 filteredMyVoices
      const voice = voiceList[index];

      if (this.currentPlayingIndex === index && this.currentPlayingType === type && this.audioElement) {
        // 如果点击的是当前正在播放的音频，则停止播放
        this.audioElement.pause();
        this.audioElement = null;
        this.currentPlayingIndex = null;
        this.currentPlayingType = null;
        voice.isPlaying = false;
      } else {
        // 停止之前播放的音频
        if (this.audioElement) {
          this.audioElement.pause();
          this.audioElement = null;
          if (this.currentPlayingType === "library") {
            this.voiceLibrary[this.currentPlayingIndex].isPlaying = false;
          } else {
            this.myVoices[this.currentPlayingIndex].isPlaying = false;
          }
        }

        // 播放新的音频
        this.audioElement = new Audio(voice.voice_url); // 使用 voice_url 播放音频
        this.audioElement.play();
        this.currentPlayingIndex = index;
        this.currentPlayingType = type;
        voice.isPlaying = true;

        // 监听音频结束事件
        this.audioElement.addEventListener("ended", () => {
          voice.isPlaying = false;
          this.currentPlayingIndex = null;
          this.currentPlayingType = null;
        });
      }
    },

    // 打开抽屉
    handleAddVoice() {
      this.drawerVisible = true;
      this.drawerStep = 1; // 重置为第一步
      this.fileList = []; // 清空上传文件列表
      this.VoiceName = ""; // 清空音色名称
      this.VoiceScene = ""; // 清空音色场景
    },
    // 处理分类按钮点击
    handleFilterClick(filter) {
      this.selectedFilter = filter;
    },



    // 操作按钮
    handleCreate(voice) {
      if (voice.is_open > 0) {
        this.$message.warning("公模声音，无操作权限！");
      } else {
        this.$message.success(`制作 ${voice.title}`);
      }
    },

    // 打开删除确认模态框
    openDeleteDialog(voice) {
      this.currentItem = voice;
      this.deleteDialogVisible = true;
    },

    // 确认删除
    async confirmDelete() {
      if (!this.currentItem) return;

      const user = auth.getStoredUser();
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_sc_api.php`, {
          action: "delete",
          user_id: user.id,
          id: this.currentItem.id,
        });

        if (response.data.success) {
          this.$message.success("删除成功");
          this.fetchVoiceData(); // 重新获取数据
        } else {
          this.$message.error(response.data.error || "删除失败");
        }
      } catch (error) {
        console.error("删除失败:", error);
        this.$message.error("删除失败，请检查网络");
      } finally {
        this.deleteDialogVisible = false;
      }
    },

    // 打开修改模态框
    openRenameDialog(voice) {
      this.currentItem = voice;
      this.renameForm.title = voice.title;
      this.renameForm.scene = voice.scene;
      this.renameDialogVisible = true;
    },

    // 确认修改
    async confirmRename() {
      if (!this.currentItem) return;

      const user = auth.getStoredUser();
      if (!user || !user.id) {
        this.$message.error("用户未登录或用户ID无效");
        return;
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/pc/api/voice_sc_api.php`, {
          action: "update",
          user_id: user.id,
          id: this.currentItem.id,
          title: this.renameForm.title,
          scene: this.renameForm.scene,
        });

        if (response.data.success) {
          this.$message.success("修改成功");
          this.fetchVoiceData(); // 重新获取数据
        } else {
          this.$message.error(response.data.error || "修改失败");
        }
      } catch (error) {
        console.error("修改失败:", error);
        this.$message.error("修改失败，请检查网络");
      } finally {
        this.renameDialogVisible = false;
      }
    },

    onDownload(voice) {
      if (!voice.voice_url) {
        this.$message.error("音频地址无效");
        return;
      }

      // 触发下载的核心方法
      const triggerDownload = (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${voice.title || 'audio'}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 释放内存
        this.$message.success("音频下载中...");
      };

      // 方案1：使用Fetch API
      const tryFetchDownload = () => {
        fetch(voice.voice_url)
          .then(response => {
            if (!response.ok) throw new Error('服务器响应异常');
            return response.blob();
          })
          .then(blob => triggerDownload(blob))
          .catch(error => {
            console.error('Fetch下载失败:', error);
            tryXHRDownload(); // 降级到XHR方案
          });
      };

      // 方案2：使用XMLHttpRequest
      const tryXHRDownload = () => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', voice.voice_url, true);
        xhr.responseType = 'blob';

        xhr.onload = function () {
          if (this.status === 200) {
            triggerDownload(this.response);
          } else {
            fallbackToOpen();
          }
        };

        xhr.onerror = function () {
          fallbackToOpen();
        };

        xhr.send();
      };

      // 最终回退方案
      const fallbackToOpen = () => {
        this.$message.warning('强制下载失败，尝试打开新窗口');
        window.open(voice.voice_url, '_blank');
      };

      // 执行下载尝试
      try {
        // 优先尝试现代下载方案
        if ('fetch' in window) {
          tryFetchDownload();
        } else {
          tryXHRDownload();
        }
      } catch (error) {
        console.error('下载异常:', error);
        fallbackToOpen();
      }
    },

    // 获取音频时长和大小限制
    async fetchvoiceClarityValues() {
      try {
        const response = await axios.get(`${config.BASE_URL}/pc/api/get_video_clarity_values.php`);
        if (response.data) {
          this.voiceDuration = response.data.voice_duration || 0; // 音频最大时长
          this.voiceSize = response.data.voice_size || 0; // 音频最大大小
        } else {
          ElMessage.error("获取音频限制失败");
        }
      } catch (error) {
        console.error("获取音频限制失败:", error);
        ElMessage.error("获取音频限制失败，请检查网络");
      }
    },
    // 上传前的校验
    async beforeUpload(file) {
      const isVoice = file.type === "audio/mp3" || file.type === "audio/wav";

      const isLtMaxSize = file.size / 1024 / 1024 < this.voiceSize; // 文件大小限制
      const isGtMinSize = file.size / 1024 / 1024 > 0.1; // 文件最小大小（0.1MB）

      // 校验文件类型
      if (!isVoice) {
        ElMessage.error("只能上传 MP3 或 WAV 格式的音频");
        return false;
      }

      // 校验文件大小
      if (!isLtMaxSize) {
        ElMessage.error(`音频大小不能超过 ${this.voiceSize}MB`);
        return false;
      }
      if (!isGtMinSize) {
        ElMessage.error("音频大小不能小于 0.1MB");
        return false;
      }

      // 校验音频时长
      const duration = await this.getVoiceDuration(file);
      if (duration < 5 || duration > this.voiceDuration) {
        ElMessage.error(`音频时长必须在 5s 到 ${this.voiceDuration}s 之间`);
        return false;
      }

      // 获取上传签名
      try {
        const signatureData = await this.getUploadSignature();
        if (!signatureData) {
          ElMessage.error("获取上传签名失败");
          return false;
        }

        // 使用签名上传文件到 OSS
        const uploadResult = await this.uploadToOSS(file, signatureData);
        if (uploadResult) {
          ElMessage.success("音频上传成功");
          return true;
        } else {
          ElMessage.error("音频上传失败");
          return false;
        }
      } catch (error) {
        console.error("上传失败:", error);
        ElMessage.error("音频上传失败，请重试");
        return false;
      }
    },

    // 获取音频时长
    getVoiceDuration(file) {
      return new Promise((resolve, reject) => {
        const audio = document.createElement('audio'); // 创建 audio 元素
        audio.src = URL.createObjectURL(file); // 设置音频文件的 URL
        audio.onloadedmetadata = () => {
          resolve(audio.duration); // 返回音频时长
        };
        audio.onerror = () => {
          reject(new Error("无法读取音频时长")); // 处理错误
        };
      });
    },

    // 获取上传签名
    async getUploadSignature() {
      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/upload_signature.php`,
          {
            type: 'audio', // 上传类型为音频
          },
          {
            headers: {
              'Content-Type': 'application/json', // 设置请求头
            },
          }
        );

        // 检查接口返回的数据
        if (response.data && response.data.success) {
          // 确保返回的数据包含所有必需的字段
          const requiredFields = ['accessKeyId', 'policy', 'signature', 'bucket', 'endpoint', 'folder'];
          for (const field of requiredFields) {
            if (!response.data[field]) {
              throw new Error(`接口返回数据缺少字段: ${field}`);
            }
          }

          // 返回签名数据
          return response.data;
        } else {
          // 如果接口返回 success 为 false，抛出错误
          throw new Error(response.data.error || "获取上传签名失败");
        }
      } catch (error) {
        console.error("获取上传签名失败:", error);
        throw error;
      }
    },

    // 上传文件到 OSS
    async uploadToOSS(file, signatureData) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("key", `${signatureData.folder}${file.name}`); // 文件路径
        formData.append("policy", signatureData.policy); // 上传策略
        formData.append("OSSAccessKeyId", signatureData.accessKeyId); // AccessKeyId
        formData.append("signature", signatureData.signature); // 签名
        formData.append("success_action_status", "200"); // 上传成功时返回的状态码
        formData.append("file", file); // 文件

        axios.post(
          `https://${signatureData.bucket}.${signatureData.endpoint}`, // OSS 上传地址
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data", // 设置请求头
            },
          }
        )
          .then((response) => {
            if (response.status === 200) {
              // 上传成功
              const voiceUrl = `https://${signatureData.bucket}.${signatureData.endpoint}/${signatureData.folder}${file.name}`;
              this.fileList = [{ name: file.name, url: voiceUrl, size: file.size }]; // 更新文件列表
              resolve(true);
            } else {
              // 上传失败
              console.error("上传失败：", response);
              reject(new Error("上传失败"));
            }
          })
          .catch((error) => {
            console.error("上传失败：", error);
            reject(error);
          });
      });
    },
  },
};
</script>

<style scoped>
.voice-cloning {
  background-color: #fff;
  padding: 20px;
}

.add-clone-button {
  display: flex;
  justify-content: left;
  margin-bottom: 20px;
}

.add-card {
  border: 2px dashed #ff5c00;
  background-color: #ffe6cc;
  border-radius: 8px;
  text-align: center;
  width: 250px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.add-card:hover {
  background-color: #ffd8a6;
}

.add-icon {
  font-size: 40px;
  color: #ff5c00;
  margin-bottom: 10px;
}

.tabs {
  margin-top: 20px;
}

.content {
  display: flex;
  flex-direction: column;
  /* 确保内容垂直排列 */
  gap: 20px;
  /* 设置间距 */
}

.voice-row {
  display: flex;
  flex-wrap: wrap;
  /* 允许换行 */
  gap: 20px;
  /* 设置卡片之间的间距 */
  justify-content: flex-start;
  /* 确保卡片从左到右排列 */
}

.voice-card-wrapper {
  flex: 1 1 calc(25% - 20px);
  /* 每行显示 4 个卡片，减去间距 */
  max-width: calc(25% - 20px);
  /* 最大宽度 */
  min-width: 200px;
  /* 卡片的最小宽度 */
}

/* 响应式布局 */
@media (max-width: 768px) {
  .voice-card-wrapper {
    flex: 1 1 calc(50% - 20px);
    /* 在小屏幕上每行显示 2 个卡片 */
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 480px) {
  .voice-card-wrapper {
    flex: 1 1 100%;
    /* 在超小屏幕上每行显示 1 个卡片 */
    max-width: 100%;
  }
}

.voice-card {
  display: flex;
  align-items: center;
  gap: 15px;
}

.play-button {
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.voice-info {
  flex-grow: 1;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}

.tag {
  font-size: 12px;
  background-color: #f2f2f2;
  color: #888;
  padding: 4px 10px;
  border-radius: 8px;
  margin-top: 5px;
  display: inline-block;
}

.create-button {
  border: 1px solid #ff5c00;
  color: #ff5c00;
  font-size: 14px;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 4px;
  margin-left: 20px;
}

.create-button:hover {
  background-color: #ffe6cc;
  color: #ff5c00;
}

.filter-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.filter-button {
  background-color: #f5f5f5;
  color: #888;
  border-radius: 5px;
  padding: 5px 15px;
  font-size: 14px;
  border: none;
  cursor: pointer;
}

.filter-button.active {
  background-color: #ff5c00;
  color: #fff;
}

.filter-button:hover {
  background-color: #ffd8a6;
  color: #000;
}

.drawer-content {
  margin-top: -30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 第一步样式 */
.step-1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-requirements h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.upload-requirements ul {
  list-style-type: disc;
  margin-left: 5px;
  color: #666;
  line-height: 1.6;
  font-size: 14px;
  background: #f7f8fa;
  padding-top: 10px;
  padding-bottom: 10px;
}

.poor-examples h4 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.examples-grid {
  display: flex;
  justify-content: center;
}

.example img {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 8px;
}

.next-step {
  text-align: center;
}

/* 第二步样式 */
.step-2 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.step-2 h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.step-2 .subtitle {
  font-size: 14px;
  color: #666;
  margin-top: -20px;

}

/* 上传框样式 */
.upload-section {
  text-align: center;
}

.upload-voice {
  border: 2px dashed #ff5c00;
  border-radius: 8px;
  background-color: #fff4e6;
  padding: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.upload-voice:hover {
  background-color: #ffe6cc;
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.upload-icon {
  font-size: 40px;
  color: #ff5c00;
}

.upload-text {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.upload-hint {
  font-size: 14px;
  color: #666;
}

/* 音色名称输入 */
.name-input {
  margin-top: 20px;
}

/* 免责声明 */
.disclaimer {
  margin-top: 20px;

}

.disclaimer h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.disclaimer ul {
  list-style-type: disc;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #666;
  line-height: 1.6;
  font-size: 14px;
  background: #f7f8fa;
}


/* 操作按钮 */
.action-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>